import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as XLSX from "xlsx";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, Grid, ExcelUpload, FormControl, Table } from "@/comn/components";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
} from "@/comn/hooks";
import { BASE, URLS, APIS, SF_LPCO_SRCH, SG_LPCO_LIST_R } from "./services/OsciCfgnFeeService";
import { CommonErrors } from "@/comn/components";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn"; // 시스템 공통 유틸
/*
 * LPCO Component List
 * !== LPCO Component List ==!
 */
export const OSCI0203022Q = () => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0004"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    //    const { dclrNo } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!
    const { openPopup } = usePopup();
    const [lpcoList, setLpcoList] = useState(comnUtils.getGridData([]));

    // ORG LPCO LIST
    const [orgLpcoList, setOrgLpcoList] = useState([]);

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0116" },
            { area: "comnCd", comnCd: "OSC0113" },
            { area: "comnCd", comnCd: "OSC0025" },
            { area: "comnCd", comnCd: "OSC0101" },
            { area: "comnCd", comnCd: "OSC0123" },
            { area: "comnCd", comnCd: "OSC0143" },
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // LPCO List Search !== LPCO List Search ==!
        lpcoSrch: useForm({
            defaultSchema: SF_LPCO_SRCH,
            defaultValues: {
                orgCd: auth.get("orgCd"),
                orgNm: auth.get("orgNm"),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Lpco List !== Lpco List ==!
        lpcoList: useGrid({
            defaultSchema: SG_LPCO_LIST_R,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const render = {
        grid_LpcoList: {
            head: {},
            cell: {
                appNm: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return <Link to={`${URLS.osci0203023s}/${rowValues.feeImpsCtraId}`}>{`${rowValues.appNm}`}</Link>;
                },
            },
        },
        edit: {},
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        /* LPCO Component List !== LPCO Component 목록 ==! */
        getLpcoList: useFetch({
            api: async (page = grid.lpcoList.page) => {
                //return APIS.getLpcoList(form.lpcoSrch.getValues(), page, grid.lpcoList.size);
                return await lpcoUtils.getComnAppPageList(
                    { ...form.lpcoSrch.getValues(), listTp: "FEE", orgCd: form.lpcoSrch.getValue("orgCd") },
                    page,
                    grid.lpcoList.size,
                );
            },
            enabled: comnUtils.isEmpty(form.lpcoSrch.errors) && form.lpcoSrch.isSubmitted,
            key: [grid.lpcoList.page, grid.lpcoList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.lpcoSrch.getValues(),
                    page: grid.lpcoList.page,
                    size: grid.lpcoList.size,
                });
            },
            onError: () => {},
            showToast: false,
        }),
        getOrgLpcoByPrcsList: useFetch({
            api: (data) => {
                return lpcoUtils.getOrgLpcoByPrcsList(data);
            },
            onSuccess: (data) => {
                setOrgLpcoList(data || []);
            },
            onError: () => {},
            showToast: false,
        }),
    };
    /*
     * 화면에서 사용하는 이벤트, 함수를 선언
     * 기본 변수명은 메타 단어 조합 카멜 표기법을 따름
     * fetch 를 호출 하는 메소드: fetch 명과 동일하게 작성
     * 버튼이나 그리드의 이벤트의 경우 : [이벤트종류]_[이벤트대상타입]_[이벤트대상명]
     * 이벤트 대상 타입 : Btn , Grid ... 카멜표기법으로 표시, 첫글자 대문자
     * 이벤트 명 : 카멜표기법으로 표시, 첫글자 대문자
     *
     * const handler = {
     *      [handler 이름] : ()=>{ 함수 },
     *      click_Btn_Save : 저장버튼 클릭
     *      click_Grid_RpckItmAppList : 재포장 품목 신청서 그리드 클릭
     *      ...
     * }
     */
    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        /* LPCO Component List !== LPCO Component 목록 ==! */
        getLpcoList: () => {
            form.lpcoSrch.handleSubmit(
                (data) => {
                    grid.lpcoList.setPage(0);
                    fetch.getLpcoList.fetch(0);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
        setInit: async () => {
            // 기관 LPCO SELECT 목록
            await fetch.getOrgLpcoByPrcsList.fetch(auth.get("orgCd"));

            // 목록 조회
            handler.getLpcoList();
        },
    };

    useEffect(() => {
        // 이전 검색 조건 세팅
        lpcoUtils.setSrchFormFromStore(form.lpcoSrch, pgeStore);
        // 초기화
        handler.setInit();
    }, []);

    return (
        <Page>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control
                                    {...form.lpcoSrch.schema.srchAppCdNo}
                                    options={orgLpcoList}
                                ></Group.Control>
                                <Group.Control {...form.lpcoSrch.schema.srchAppTp}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.lpcoSrch.schema.srchAtcmTpCd}></Group.Control>
                                <Group.Control {...form.lpcoSrch.schema.srchUseYn}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.lpcoSrch.schema.srchLpcoAplyTpCd}></Group.Control>{" "}
                            </Group.Row>

                            <Group.Row>
                                <Group.Control {...form.lpcoSrch.schema.srchFeeRuleNm}></Group.Control>
                                <Group.Control {...form.lpcoSrch.schema.srchFeeImpsTpCd}></Group.Control>
                            </Group.Row>
                        </Group.Section>

                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.lpcoSrch.reset();
                                        handler.getLpcoList();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.getLpcoList();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>
            <Group>
                <Group.Body>
                    <Group.Title title={"L_SRCH_RSTS"} titleSize={2}></Group.Title>
                    {/*
                     * 그리드
                     * @ 그리드 스키마 주입 : {...grid.[그리드이름].grid}
                     * @ 데이터 data={fetch.[fetch 명].data?.[api 리턴 vo 명]}
                     * @ 셀클릭이벤트 연결 : onCellClick={handler.[그리드 이벤트 핸들러명]}
                     */}
                    <Grid
                        {...grid.lpcoList.grid}
                        data={fetch.getLpcoList.data?.lpcoList}
                        render={render.grid_LpcoList}
                        // onCellClick={handler.click_Grid_RpckItmAppList}
                        // onRowClick={handler.click_GridRow_RpckItmAppList}
                    />
                </Group.Body>
            </Group>
        </Page>
    );
};
